var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoSystemoffline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "-204 206 90 90",
    style: {
      enableBackground: "new -204 206 90 90"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#DE2255;}\r\n\t.st1{fill:none;stroke:#4E4D50;stroke-width:3.2199;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-136.1,256.7c9.3,0,16.9,7.6,16.9,16.9c0,9.3-7.6,16.9-16.9,16.9s-16.9-7.6-16.9-16.9 C-153,264.3-145.4,256.7-136.1,256.7 M-136.1,253.5c-11.1,0-20.1,9-20.1,20.1c0,11.1,9,20.1,20.1,20.1s20.1-9,20.1-20.1 C-116,262.5-125,253.5-136.1,253.5L-136.1,253.5z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-119.7,249.4c0-22.7-18.4-41.1-41.1-41.1s-41.1,18.4-41.1,41.1s18.4,41.1,41.1,41.1"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: -202,
    y1: 249.4,
    x2: -119.7,
    y2: 249.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: -160.9,
    y1: 208.3,
    x2: -160.9,
    y2: 290.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-139.2,249.4c0-22.7-9.7-41.1-21.6-41.1c-12,0-21.6,18.4-21.6,41.1s9.7,41.1,21.6,41.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-121.3,249.4c0-10.6-17.7-19.2-39.6-19.2s-39.6,8.6-39.6,19.2c0,10.6,17.7,19.2,39.6,19.2"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-136.2,280.6c-1.1,0-1.9,0.8-1.9,1.9c0,1.1,0.8,1.9,1.9,1.9c1.1,0,1.9-0.8,1.9-1.9 C-134.3,281.3-135.1,280.6-136.2,280.6L-136.2,280.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "-134.7,264.8 -137.5,264.8 -137.2,277.9 -135,277.9 -134.7,264.8  "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoSystemoffline);
export default __webpack_public_path__ + "static/media/ico_systemoffline.225bd864c2d091f15847d015102778ab.svg";
export { ForwardRef as ReactComponent };